import { useEffect } from 'react';

/**
 * Hook for handling focusMission events from search navigation
 */
export function useFocusMission() {
  useEffect(() => {
    const handleFocusMission = (e) => {
      const { missionId, view } = e.detail;
      if (view !== 'todolist' || !missionId) return;
      
      setTimeout(() => {
        const rowElement = document.querySelector(`[data-todo-id="${missionId}"]`);
        if (rowElement) {
          // Use instant scroll so element is immediately visible
          rowElement.scrollIntoView({ behavior: 'instant', block: 'center' });
          
          // Flash highlight immediately after instant scroll
          // Duration matches the CSS animation (1.8s pulse + fade)
          rowElement.classList.add('todo-item--highlighted');
          setTimeout(() => {
            rowElement.classList.remove('todo-item--highlighted');
          }, 2000);
        }
      }, 100);
    };
    
    window.addEventListener('focusMission', handleFocusMission);
    return () => window.removeEventListener('focusMission', handleFocusMission);
  }, []);
}
